import React, { useState, useEffect } from 'react';
import { apiFetch } from '../services/apiClient';
import './GreetingMessageEditor.css';

const GreetingMessageEditor = ({ jobId }) => {
    const [greeting, setGreeting] = useState('');
    const [defaultGreeting, setDefaultGreeting] = useState('');
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchGreeting();
        fetchDefaultGreeting();
    }, [jobId]);

    const fetchGreeting = async () => {
        try {
            const response = await apiFetch(`/api/jobs/${jobId}/greeting`, {
            });
            if (response.ok) {
                const data = await response.json();
                setGreeting(data.greeting_message || '');
            }
        } catch (error) {
            console.error('Error fetching greeting:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchDefaultGreeting = async () => {
        try {
            const response = await apiFetch('/api/default-greeting', {
            });
            if (response.ok) {
                const data = await response.json();
                setDefaultGreeting(data.message);
            }
        } catch (error) {
            console.error('Error fetching default greeting:', error);
        }
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const response = await apiFetch(`/api/jobs/${jobId}/greeting`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ greeting_message: greeting })
            });
            
            if (response.ok) {
                setSaved(true);
                setTimeout(() => setSaved(false), 2000);
            } else {
                alert('Failed to save greeting message');
            }
        } catch (error) {
            console.error('Error saving greeting:', error);
            alert('Error saving greeting message');
        } finally {
            setSaving(false);
        }
    };

    const handleReset = () => {
        if (window.confirm('Reset to default greeting message?')) {
            setGreeting(defaultGreeting);
        }
    };

    if (loading) {
        return <div className="greeting-editor">Loading...</div>;
    }

    return (
        <div className="greeting-editor">
            <h3>Greeting Message</h3>
            <p className="help-text">
                This message will be shown to candidates before they fill out the application form.
                If left empty, the default message will be used.
            </p>
            
            <textarea
                value={greeting}
                onChange={(e) => setGreeting(e.target.value)}
                placeholder={defaultGreeting}
                rows={8}
                className="greeting-textarea"
            />
            
            <div className="editor-actions">
                <button 
                    onClick={handleSave} 
                    disabled={saving}
                    className="save-button"
                >
                    {saving ? 'Saving...' : 'Save Greeting'}
                </button>
                <button 
                    onClick={handleReset} 
                    className="reset-button"
                >
                    Reset to Default
                </button>
                {saved && <span className="saved-indicator">✓ Saved!</span>}
            </div>
            
            <div className="preview-section">
                <h4>Preview:</h4>
                <div className="greeting-preview">
                    {greeting || defaultGreeting}
                </div>
            </div>
        </div>
    );
};

export default GreetingMessageEditor;
